import Drawable from "./Drawable";
import { Line } from "react-konva";
import React from "react";

export default class LineDrawable extends Drawable {
  x: number;
  y: number;
  drawableType = 'LineDrawable';
  constructor(startx, starty, color, weight, opacity) {
    super(startx, starty, color, weight, opacity);
    this.x = startx;
    this.y = starty;
    this.color = color;
    this.weight  = weight;
  }
  registerMovement(x, y) {
    this.x = x;
    this.y = y;
  }
  render() {
    const points = [this.startx, this.starty, this.x, this.y];
    return <Line points={points} fill={this.color} stroke={this.color} strokeWidth={this.weight} opacity={this.opacity}/>;
  }
}